import { Controller } from "@hotwired/stimulus";
import { parseValue } from "../lib/cart_helpers";

export default class extends Controller {
  static targets = ["total"];
  static outlets = ["line-item"];

  static values = {
    lineItemSubtotal: Number,
    shipping: Number,
    taxes: Number,
    other: Number,
    total: Number
  }

  connect() {
    this.calculate();
  }

  calculate() {
    this.totalValue = this.lineItemSubtotalValue +
      this.shippingValue +
      this.taxesValue +
      this.otherValue;
  }

  calculateSubtotal() {
    this.lineItemSubtotalValue = this.lineItemOutlets.reduce(
      (accum, outlet) => accum + outlet.subtotalValue,
      0
    );
  }

  update({ currentTarget, params: { formatType, valueType } }) {
    this[`${valueType}Value`] = parseValue(currentTarget.value, formatType);
  }

  lineItemSubtotalValueChanged = this.calculate
  otherValueChanged = this.calculate
  shippingValueChanged = this.calculate
  taxesValueChanged = this.calculate

  totalValueChanged() {
    const formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

    if ("value" in this.totalTarget) {
      this.totalTarget.value = formatter.format(this.totalValue);
      this.totalTarget.dispatchEvent(new Event("input", { bubbles: true }));
    }
    else {
      this.totalTarget.innerText = formatter.format(this.totalValue);
    }
  }
}
